import { Routes, Route, Navigate } from 'react-router-dom';
import { ErrorBoundary } from '../../components/ErrorBoundary';
import { AdminDashboard } from './AdminDashboard';
import { UserManagementHub } from './users/UserManagementHub';
import { AuditLog } from './audit/AuditLog';
import { OrganizationSettings } from './organization/OrganizationSettings';
import { OrgChart } from '../people/orgchart/OrgChart';
import { SecurityKernel } from './security/SecurityKernel';
import { Subscription } from './subscription/Subscription';
import { ApiIntegrations } from './api/ApiIntegrations';
import { SystemHealth } from './system/SystemHealth';

export function AdminHub() {
  return (
    <div className="admin-hub">
      <ErrorBoundary>
        <Routes>
        {/* Dashboard Overview */}
        <Route index element={<AdminDashboard />} />

        {/* Platform Settings Redirect */}
        <Route path="/platform" element={<Navigate to="/admin/access" replace />} />

        {/* Organization Management */}
        <Route path="/organization" element={<OrganizationSettings />} />
        <Route path="/orgchart" element={<OrgChart title="Organization Chart" />} />

        {/* User Management, Roles, Permissions, User Access, and Security */}
        <Route path="/users" element={<UserManagementHub initialTab="users" />} />
        <Route path="/roles" element={<UserManagementHub initialTab="roles" />} />
        <Route path="/permissions" element={<UserManagementHub initialTab="permissions" />} />
        <Route path="/matrix" element={<UserManagementHub initialTab="matrix" />} />
        <Route path="/access" element={<UserManagementHub initialTab="access" />} />
        <Route path="/security" element={<UserManagementHub initialTab="security" />} />

        {/* Audit & Compliance */}
        <Route path="/audit" element={<AuditLog />} />

        {/* Subscription & Module Management */}
        <Route path="/subscription" element={<Subscription />} />

        {/* API & Integrations */}
        <Route path="/api" element={<ApiIntegrations />} />

        {/* System Monitoring */}
        <Route path="/system" element={<SystemHealth />} />

        {/* Fallback to organization settings */}
        <Route path="/settings" element={<OrganizationSettings />} />
      </Routes>
      </ErrorBoundary>
    </div>
  );
}
